<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle1"><a id="page_xiii"></a>ACKNOWLEDGMENT</h2>
<p class="noindent">The Editor wishes to acknowledge with thanks the many individuals who helped make this work possible. Without the help and forbearance of the librarians of the New York City Library, the Columbia Law Library, the Rutgers Law Library and the Library of Congress, this work would have been impossible.</p>
<p class="indent">Specific material sources, other than public documents on file with the Library of Congress, are as follows:</p>
<p class="indent-ha"><em class="italic">Ancient Codes &amp; Laws of the Near East</em>, ed. Driver &amp; Miles, Vol. II, Oxford Press, 1955. From pages 7–37.</p>
<p class="indent-ha">The Code Napoleon, being The French Civil Code translated by Robert Samuel Richards, London, Widdy &amp; Sons.</p>
<p class="indent-ha">Consulate of the Sea, translation of the Chapter CCLXII of the Consulado del Mar, relating to prize law, London, W. Wilson for J. White and J. Butterworth, 1800, translated by Sir Christopher Robinson.</p>
<p class="indent-ha">Naval War College, <em class="italic">International Law Topics</em>, Declaration of London—pp. 169–193, 1909.</p>
<p class="indent-ha"><em class="italic">Year Book on Human Rights for 1946</em>, U.N. Publications, 1948, XIV, 1, pp. 1–6, 107.</p>
<p class="indent-ha"><em class="italic">A Digest of International Law</em>, John Bassett Moore, Vol. VII, Washington, Government Printing Office, 1906, pp. 561–562.</p>
<p class="indent-ha"><em class="italic">English Historical Documents</em>, ed. by David C. Douglas, New York, Oxford University Press, 1953, pp. 847–850, 854–866.</p>
<p class="indent-ha"><em class="italic">Documents of American History</em>, Commager, 6th ed. 1–2, pp. 15–16; 224–227.</p>
<p class="indent-ha">Lipit—Istar’s Law in <em class="italic">Ancient Codes &amp; Laws of the Near East</em>, Driver &amp; Miles, Vol. II, Oxford Press, 1955, pp. 306–307, 309, 311,313.</p>
<p class="indent-ha">Magna Charta, the Bill of Rights with the Petition of Right, London, published by J. Bailey.</p>
<a id="page_xiv"></a>
<a id="page_xv"></a>
<a id="page_xvi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Ack.vue?2d53b2f6